import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <>
      <main>
        <h2>Страница не найдена</h2>
        <p>404</p>
      </main>
      <nav>
        <Link to="/">Home</Link>
      </nav>
    </>
  );
}
